import axios from 'axios'

export default {
    _pendingDisconnect (payload) {
        return axios.get(`https://api.breezeline.com/api/v1/slbos/pending-disconnect`, { params: { ...payload } })
            .then(response => response.data)
            .catch(error => {
                throw error.response.data
            })
    },
    _checkAddress (payload) {
        return axios.get(`/api/check-addresses`, { params: { ...payload } })
            .then(response => response.data)
            .catch(error => {
                throw error.response.data
            })
    },
    _selectAddress (payload) {
        return axios.post(`/api/check-addresses`, { ...payload })
            .then(response => response.data)
            .catch(error => {
                throw error.response.data
            })
    },
    _verifyAddressAndSelectProduct (payload) {
        return axios.post(`/api/verify-address-and-select-product`, { ...payload })
            .then(response => response.data)
            .catch(error => {
                throw error.response.data
            })
    },
    _fetchAvailableOffers (payload) {
        return axios.get(`/api/location-service`, { params: { ...payload } })
            .then(response => response.data)
            .catch(error => {
                throw error.response.data
            })
    },
    _selectOffer (payload) {
        return axios.post('api/offer-selection', { ...payload })
            .then(response => response.data)
            .catch(error => {
                throw error.response.data
            })
    },
    _fetchPromotions() {
        return axios.get(`/api/promos/static`)
            .then(response => response.data)
            .catch(error => {
                console.error('Error fetching promotions:', error);
                throw error.response ? error.response.data : error;
            });
    }
}
